import React from 'react';
import { EmptyState } from '../../components';
import { LINK_SESSION_STATUS } from '../../hooks/useAgendeaiLinkSession';
import { NOT_RESCHEDULABLE_MESSAGE } from '../../utils/linkSession';
import LinkSessionStatus from '../_shared/LinkSessionStatus';

function AttendanceRescheduleForm({ status, onRetryPress }) {
	if (status === LINK_SESSION_STATUS.NOT_RESCHEDULABLE) {
		return (
			<EmptyState
				icon="calendar-xmark"
				title={NOT_RESCHEDULABLE_MESSAGE}
				description="Entre em contato com a clínica para mais informações."
			/>
		);
	}

	return (
		<LinkSessionStatus
			status={status}
			expiredDescription="Solicite um novo link para remarcar o seu agendamento."
			onRetryPress={onRetryPress}
		/>
	);
}

export default AttendanceRescheduleForm;
